<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <kendo-panelbar #panelbar>
      <kendo-panelbar-item 
                           [expanded]="true">
        <ng-template kendoPanelBarItemTitle>
          <span>TRAINING MODULES</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!modulesSchool.isTrainingPanelValid && modulesSchool.isTrainingPanelContinue"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="modulesSchool.isTrainingPanelValid && modulesSchool.isTrainingPanelContinue"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <form [formGroup]="trainingDetailsForm">
                <div class="form-group">
                  <label class="lbl">Language</label>
                  <!--(selectionChange)="lanaguageChange($event)"-->
                  <kendo-dropdownlist class="kendoInput" name="languageCode"
                                      formControlName="languageCode"
                                      [data]="getLanguages"
                                      [textField]="'languageCode'"
                                      [valueField]="'languageCode'"
                                      [ngModel]="{languageCode:selectedLanguage,languageCode:selectedLanguage}" (selectionChange)="lanaguageChange($event)" (blur)="validateTrainingForm()" [ngClass]="{'borderRed':modulesSchool.isLanguageCodeEmpty && modulesSchool.isTrainingPanelContinue}">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    Training Name
                  </label>
                  <input type="text" kendoTextBox class="kendoInput" name="trainingName" formControlName="trainingName" (blur)="validateTrainingForm()" [ngClass]="{'borderRed':modulesSchool.isEmptyTrainingName && modulesSchool.isTrainingPanelContinue}" />
                </div>
                <div class="form-group">
                  <kendo-label class="k-radio-label"
                               [for]="terms"
                               text="Input Method &nbsp; &nbsp;   "></kendo-label>
                  <input type="radio"
                         name="trainingInputMethod"
                         value="TextEditor"
                         #textEditor [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="trainingInputMethod"
                         kendoRadioButton />
                  <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

                  <input type="radio"
                         name="trainingInputMethod"
                         value="FileUpload"
                         #fileUpload [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="trainingInputMethod"
                         kendoRadioButton />
                  <label class="k-label" [for]="fileUpload">File Upload</label>
                </div>
                <div class="form-group" [hidden]="trainingInputMethod==='FileUpload'">
                  <label class="lblCls">
                    Training Description
                  </label>
                  <!--<textarea kendoTextArea class="kendoInput textArea-height"
      formControlName="trainingDescription" name="trainingDescription" (blur)="validateTrainingForm()" [ngClass]="{'borderRed':modulesSchool.isEmptyTrainingDescription && modulesSchool.isTrainingPanelContinue}"></textarea>-->
                  <kendo-editor class="kendoInput" formControlName="trainingDescription" 
                                name="trainingDescription" (blur)="validateTrainingForm()" [ngClass]="{'borderRed':modulesSchool.isEmptyTrainingDescription && modulesSchool.isTrainingPanelContinue}"></kendo-editor>
                </div>
                <div class="form-group" *ngIf="trainingInputMethod==='FileUpload'">
                  <div class="kendoInput">
                    <app-upload [multiple]="false" (fileSelect)="trainingSelected($event)"
                                [uploadFolderPath]="'TempDocs\\Training'"
                                [ngClass]="{'borderRed':modulesSchool.isEmptyTrainingUrlPath && modulesSchool.isTrainingPanelContinue}"
                                (uploadSuccess)="trainingUploadSuccess($event)"
                                [fileRestrictions]="fileRestrictions"></app-upload>
                  </div>
                  <!--<label class="lblCls">
                    {{trainingUrlPath}}
                  </label>-->

                </div>
                <div class="form-group" *ngIf="trainingInputMethod==='FileUpload'">
                  <div id="pdfIframediv" class="row myIframe" *ngIf="trainingUrl">
                    <iframe class="PdfReport"
                            [src]="trainingUrl"
                            type="application/pdf"></iframe>
                  </div>
                </div>
                <!--<h6>Module Details</h6>

                <div formArrayName="moduleFormValue" *ngFor="let a of trainingDetailsForm.get('moduleFormValue').controls; let i = index">
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Modules Name
                          </label>
                          <input type="text" class="kendoInput" kendoTextBox
                                 formControlName="moduleName" name="moduleName" />
                        </div>

                        <div class="form-group">
                          <label class="lblCls">
                            Start Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="startDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Modules Short Description
                          </label>
                          <input type="text" class="kendoInput" kendoTextBox
                                 formControlName="moduleShortDescription" name="moduleShortDescription" />
                        </div>
                        <div class="form-group">
                          <label class="lblCls">
                            End Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="endDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Price
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="price" formControlName="price" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Total Seats
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="totalSeats" formControlName="totalSeats" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Modules Description
                          </label>
                          <textarea kendoTextArea class="kendoInput"
                                    formControlName="modulesDescription" name="modulesDescription"></textarea>
                        </div>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-sm-12 justify-content-center">
                        <button type="button" kendoButton (click)="deleteModule(i)"
                                class="btn btn-success">
                          Delete
                        </button>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>

                <div class="d-flex justify-content-center col-xs-12 col-sm-12">
                  <button type="button" kendoButton (click)="addNewModule()"
                          class="btn btn-success">
                    Add New Module
                  </button>
                </div>-->
              </form>
            </div>
            <div class="col-sm-2"></div>
          </div>
          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel('training module')">
              Continue
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item 
                           [expanded]="false" (click)="onLocationPanelChange($event)">
        <ng-template kendoPanelBarItemTitle>
          <span>LOCATION INFORMATION</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!modulesSchool.isLocationInfoPanelValid && modulesSchool.isLocationInfoContinue"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="modulesSchool.isLocationInfoPanelValid && modulesSchool.isLocationInfoContinue"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <form [formGroup]="locationInfoForm">

                <div formArrayName="locationFormValue" *ngFor="let a of locationInfoForm.get('locationFormValue').controls; let i = index">
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Location Name
                          </label>
                          <input type="text" kendoTextBox class="kendoInput" formControlName="locationName" />
                        </div>

                        <div class="form-group">
                          <label class="lblCls">
                            Start Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="startDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                        <!--<div class="form-group">
      <label class="lblCls">
        Price
      </label>
      <kendo-numerictextbox class="kendoInput" name="price" formControlName="price" [decimals]="0"
                            [format]="'#'" [spinners]="false">
      </kendo-numerictextbox>
    </div>-->
                      </div>
                      <div class="col-sm-6">
                        <!--<div class="form-group">
      <label class="lblCls">
        Total Seats
      </label>
      <kendo-numerictextbox class="kendoInput" name="totalSeats" formControlName="totalSeats" [decimals]="0"
                            [format]="'#'" [spinners]="false">
      </kendo-numerictextbox>
    </div>-->


                        <div class="form-group">
                          <label class="lblCls">
                            Location Description
                          </label>
                          <textarea kendoTextArea class="kendoInput"
                                    formControlName="locationDescription" name="locationDescription"></textarea>
                        </div>

                        <div class="form-group">
                          <label class="lblCls">
                            End Date
                          </label>
                          <kendo-datepicker class="kendoInput" formControlName="endDate"
                                            placeholder="MM/DD/YYYY"
                                            format="MM/dd/yyyy" [min]="todayDate"
                                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}">
                          </kendo-datepicker>
                        </div>
                      </div>


                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Total Seats
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="totalSeats" formControlName="totalSeats" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Available Seats
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="availableSeats" formControlName="availableSeats" [decimals]="0"
                                                [format]="'#'" [spinners]="false" disabled>
                          </kendo-numerictextbox>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label class="lblCls">
                            Price
                          </label>
                          <kendo-numerictextbox class="kendoInput" name="price" formControlName="price" [decimals]="0"
                                                [format]="'#'" [spinners]="false">
                          </kendo-numerictextbox>
                        </div>
                      </div>
                      <!--<div class="col-sm-6">
                         <label class="lblCls">
                           Select Module
                         </label>
                        <kendo-multiselect [data]="allModuleList"  formControlName="selectedModule" [valueField]="'moduleName'" [textField]="'moduleName'">
     <ng-template kendoMultiSelectItemTemplate let-dataList>
       <span class="template">{{dataList.moduleName}}</span>
     </ng-template>
   </kendo-multiselect>
                      <input type="text" kendoTextBox class="kendoInput" formControlName="selectedModule" />
                    </div>-->
                      </div>
                    <div class="row">
                      <div class="col-sm-12 d-flex" style="justify-content:right;">
                        <button type="button" kendoButton (click)="deleteModuleLocation(i)"
                                class="btn btn-success">
                          Delete
                        </button>
                      </div>
                    </div>
                    <hr />
                  </div>
                </div>

                <div class="d-flex justify-content-center col-xs-12 col-sm-12">
                  <button type="button" kendoButton (click)="addNewLocation()"
                          class="btn btn-success">
                    Add Location
                  </button>
                </div>
              </form>
            </div>
            <div class="col-sm-2"></div>

          </div>

          <div class="d-flex justify-content-center col-xs-12 col-sm-12">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToNextPanel('location')">
              Continue
            </button>
          </div>
        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span>WAIVER/OTHER</span>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!modulesSchool.isRegistrtionPanelValid && this.modulesSchool.isSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="modulesSchool.isRegistrtionPanelValid && modulesSchool.isSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <div class="row m-top">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="form-group">
                <kendo-label class="k-radio-label"
                             [for]="terms"
                             text="Input Method &nbsp; &nbsp;   "></kendo-label>
                <input type="radio"
                       name="registrationInputMethod"
                       value="TextEditor"
                       #textEditor [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="registrationInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="textEditor">Text Editor &nbsp;</label>

                <input type="radio"
                       name="registrationInputMethod"
                       value="FileUpload"
                       #fileUpload [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="registrationInputMethod"
                       kendoRadioButton />
                <label class="k-label" [for]="fileUpload">File Upload</label>
              </div>
              <div class="form-group" [hidden]="registrationInputMethod==='FileUpload'">
                <label class="lblCls">
                  Registration Description
                </label>
                <!--<textarea kendoTextArea class="kendoInput textArea-height"
          [(ngModel)]="registrationDescription" (blur)="validateRegistrationForm()" [ngClass]="{'borderRed':modulesSchool.isEmptyRegistrationDescription && modulesSchool.isSubmitted}"></textarea>-->
                <kendo-editor class="kendoInput" [(ngModel)]="registrationDescription" (blur)="validateRegistrationForm()" [ngClass]="{'borderRed':modulesSchool.isEmptyRegistrationDescription && modulesSchool.isSubmitted}"></kendo-editor>
              </div>
              <div class="form-group" *ngIf="registrationInputMethod==='FileUpload'">
                <div class="kendoInput">
                  <app-upload [multiple]="false" (fileSelect)="registrationSelected($event)"
                              [uploadFolderPath]="'TempDocs\\ModulesSchool'"
                              [ngClass]="{'borderRed':modulesSchool.isEmptyregistrationUrlPath && modulesSchool.isEmptyRegistrationDescription}"
                              (uploadSuccess)="registrationUploadSuccess($event)"
                              [fileRestrictions]="fileRestrictions"></app-upload>
                </div>
                <!--<label class="lblCls">
            {{registrationUrlPath}}
          </label>-->

              </div>
              <div class="form-group" *ngIf="registrationInputMethod==='FileUpload'">
                <div id="pdfIframediv" class="row myIframe" *ngIf="registrationUrl">
                  <iframe class="PdfReport"
                          [src]="registrationUrl"
                          type="application/pdf"></iframe>
                </div>
              </div>
            </div>
            <div class="col-sm-2"></div>         
          </div>

        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </div>
  <div class="col-12">
    <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
      <button kendoButton
              (click)="resetForm('cancel')" class="m-3" primary="true">
        Cancel
      </button>
      <!--[disabled]="saveInProcess"-->
      <button kendoButton
              (click)="save()" class="m-3" primary="true">
        Save<!--<kendo-loader style="color:blue"></kendo-loader>-->
      </button>
      <!--[disabled]="saveInProcess" *ngIf="saveInProcess"-->
    </div>
  </div>
</div>

